import Vue from "vue"
import vuetify from '@/plugins/vuetify'
import App from "./App.vue"
import Cookies from 'js-cookie'
import router from "./router/"
import VueHtmlToPaper from 'vue-html-to-paper';
import store from "./store"
import "./registerServiceWorker"
import "roboto-fontface/css/roboto/roboto-fontface.css"
import "font-awesome/css/font-awesome.css"
import i18n from "./lang/lang"
import "./theme/modern.css"

const options = {
  name: '_blank',
  specs: [
    'fullscreen=yes',
    'titlebar=yes',
    'scrollbars=yes'
  ],
  styles: [
'https://fonts.googleapis.com/css?family=Roboto:300,400,500,700%7CMaterial+Icons',
'https://cdn.jsdelivr.net/npm/vuetify@2.x/dist/vuetify.min.css'
  ]
}
 
Vue.use(VueHtmlToPaper, options);
Vue.config.productionTip = false;

Object.defineProperty(Vue.prototype, "store", { value: store });
new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App)
}).$mount("#app")
